// (A) 중립 Tree API — antd 미접촉. (B) 자체 헤드리스 구현 HeadlessTree 에 위임.
import { forwardRef } from 'react'
import type { CSSProperties, ReactNode } from 'react'
import { HeadlessTree } from '../_impl/tree/HeadlessTree'

export interface OmwTreeNode {
  key: string
  title?: ReactNode
  children?: OmwTreeNode[]
  icon?: ReactNode
  isLeaf?: boolean
  disabled?: boolean
  selectable?: boolean
  className?: string
  style?: CSSProperties
  [extra: string]: unknown
}

export interface OmwTreeSelectInfo {
  selected: boolean
  node: OmwTreeNode
  selectedNodes?: OmwTreeNode[]
  nativeEvent: MouseEvent
}

export interface OmwTreeExpandInfo {
  expanded: boolean
  node: OmwTreeNode
  nativeEvent: MouseEvent
}

export interface OmwTreeCheckInfo {
  checked: boolean
  node: OmwTreeNode
  nativeEvent: MouseEvent
}

export interface OmwTreeSwitcherProps {
  expanded?: boolean
  [extra: string]: unknown
}

/** ref 핸들(실측: OrgChart·mailbox 가 scrollTo 사용). */
export interface OmwTreeRef {
  scrollTo: (config: { key: string; align?: 'top' | 'bottom' | 'auto'; offset?: number }) => void
}

export interface OmwTreeProps {
  treeData: OmwTreeNode[]
  selectable?: boolean
  multiple?: boolean
  selectedKeys?: string[]
  onSelect?: (keys: string[], info: OmwTreeSelectInfo) => void
  expandedKeys?: string[]
  onExpand?: (keys: string[], info: OmwTreeExpandInfo) => void
  autoExpandParent?: boolean
  defaultExpandAll?: boolean
  defaultExpandParent?: boolean
  checkable?: boolean
  checkedKeys?: string[]
  onCheck?: (keys: string[], info: OmwTreeCheckInfo) => void
  switcherIcon?: (props: OmwTreeSwitcherProps) => ReactNode
  titleRender?: (node: OmwTreeNode) => ReactNode
  showIcon?: boolean
  virtual?: boolean
  height?: number
  disableMotion?: boolean
  onClick?: (e: MouseEvent, node: OmwTreeNode) => void
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}

export const OmwTree = forwardRef<OmwTreeRef, OmwTreeProps>(function OmwTree(props, ref) {
  return <HeadlessTree {...props} treeRef={ref} />
})
